import React, { useEffect, useMemo, useState } from "react";
import { debounce } from "lodash";
import DropdownSearchServerSingle from "../../../../../../../components/DropdownSearchServerSingle";
import { getDeskimoUsersService } from "../../../../../../User/services/EmployeeServices";

export type UserOption = { id: number | string; text: string };

type Props = {
  value: UserOption;
  onChange: (user: UserOption) => void;
  error?: string;
  touched?: boolean;
};

const DropdownUser = ({ value, onChange, error, touched }: Props) => {
  const [options, setOptions] = useState<UserOption[]>([]);

  const _fetchOptions = async (keyword = "") => {
    try {
      const { data } = await getDeskimoUsersService({
        keyword,
        page: 1,
        market_code: "",
        company_id: "",
      });
      setOptions(
        (data?.users || []).map(
          ({
            id,
            full_name,
            email,
          }: {
            id: number;
            full_name: string;
            email: string;
          }) => ({
            id,
            text: full_name ? `${full_name} (${email})` : email,
          })
        )
      );
    } catch (e) {
      console.log(e);
    }
  };

  const _debounceFetch = useMemo(() => debounce(_fetchOptions, 500), []);

  useEffect(() => {
    _fetchOptions();
    return () => _debounceFetch.cancel();
  }, []);

  return (
    <DropdownSearchServerSingle
      value={value}
      options={options}
      onSearch={_debounceFetch}
      onChange={onChange}
      placeholder={"Search user by name or email"}
      isFullWidth
      error={error}
      touched={touched}
    />
  );
};

export default DropdownUser;
